/* eslint-disable no-restricted-imports */

import { Card, CardContent, Grid, Typography } from '@material-ui/core';

import PropTypes from 'prop-types';

import { useStyles } from './styles';

export default function CustomerCard({ customer, title = 'Cliente Selecionado' }) {
  const classes = useStyles();

  if (!customer) return null;

  const phone = customer.DDD1 && customer.FONE ? `(${customer.DDD1}) ${customer.FONE}` : '';

  return (
    <Card className={classes.card}>
      <CardContent>
        <Typography variant='h6' gutterBottom className={classes.title}>
          {title}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant='body2' color='textSecondary'>
              Nome
            </Typography>
            <Typography variant='body1'>{customer.NOME}</Typography>
          </Grid>
          {customer.APELIDO && (
            <Grid item xs={12} md={6}>
              <Typography variant='body2' color='textSecondary'>
                Apelido
              </Typography>
              <Typography variant='body1'>{customer.APELIDO}</Typography>
            </Grid>
          )}
          <Grid item xs={12} md={6}>
            <Typography variant='body2' color='textSecondary'>
              CNPJ/CPF
            </Typography>
            <Typography variant='body1'>{customer.CGC}</Typography>
          </Grid>
          {customer.EMAIL && (
            <Grid item xs={12} md={6}>
              <Typography variant='body2' color='textSecondary'>
                E-mail
              </Typography>
              <Typography variant='body1'>{customer.EMAIL}</Typography>
            </Grid>
          )}
          {phone && (
            <Grid item xs={12} md={6}>
              <Typography variant='body2' color='textSecondary'>
                Telefone
              </Typography>
              <Typography variant='body1'>{phone}</Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
}

CustomerCard.propTypes = {
  customer: PropTypes.shape({
    CODIGO: PropTypes.number,
    NOME: PropTypes.string,
    APELIDO: PropTypes.string,
    CGC: PropTypes.string,
    EMAIL: PropTypes.string,
    DDD1: PropTypes.string,
    FONE: PropTypes.string,
  }),
  title: PropTypes.string,
};
